import Vue from 'vue';
import VueCompositionAPI, { defineAsyncComponent } from '@vue/composition-api';
import VueSmoothScroll from 'vue2-smooth-scroll';
import { VueClickOutside } from '@nespresso/vue-core/directives';
import { mountConfiguratorOnce } from '@nespresso/vue-configurator';

import polyfills from './polyfills';
import { registerFilters } from './filters';

import '@/styles/main.scss';

Vue.use(VueCompositionAPI);
Vue.use(VueSmoothScroll);
Vue.use(VueClickOutside);

registerFilters();

const configurator = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "configurator" */
    '@/components/Configurator/Configurator'
  )
);

Promise.all(polyfills)
  .then(() => mountConfiguratorOnce(configurator))
  .catch(error => {
    console.error('Failed fetching polyfills', error);
  });
